import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const WordIcon: React.FC<IconProps> = props => (
  <Icon viewBox="0 0 36 36" {...props}>
    <rect width="100%" height="100%" rx="4" fill="#1354BA" />
    <path
      d="M11.9411 23.4114C11.9411 23.9051 11.9411 24.3228 11.9411 24.7025C11.9411 24.3608 11.9411 23.943 11.9411 23.4494C11.9958 23.0252 12.0847 22.6061 12.207 22.1962L15.5487 7.61393H19.9158L23.7513 21.8544C23.9717 22.7402 24.1241 23.6416 24.207 24.5506C24.207 23.7911 24.3968 22.9177 24.5867 21.9304L27.3588 7.5H31.3462L26.4475 28.3861H21.8525L18.5108 14.5633C18.5108 14.1456 18.3209 13.6519 18.207 13.0063C18.093 12.3608 18.0171 11.9051 17.9791 11.6013C17.9791 11.943 17.9791 12.4367 17.7513 13.1203C17.5234 13.8038 17.5614 14.2595 17.4854 14.6013L14.4854 28.5H9.5867L4.64999 7.61393H8.67531L11.7133 22.2342C11.8109 22.6221 11.8869 23.0151 11.9411 23.4114Z"
      fill="white"
    />
  </Icon>
)
